<template>
  <div>
    <v-card class="pa-4">
      <p class="text-2xl ma-5 mb-9">
        Etes vous sur de vouloir supprimer le mapping #{{ id }} ?
      </p>
      <v-row class="mx-1 my-3">
        <v-card-text>
          <v-form ref="confirmationForm">
            <v-row>
              <v-col cols="12">
                <v-btn
                  color="primary"
                  class="me-3 mt-3"
                  @click.native="deleteMapping"
                  >Supprimer
                </v-btn>
                <v-btn
                  color="secondary"
                  outlined
                  class="mt-3"
                  @click.native="emit('openDialog', false)"
                >
                  Annuler
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";

export default {
  name: "DelConfirmation",
  props: {
    dialogOpen: {
      type: Boolean,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { axiosDelete } = useAxios();
    const { store } = useProxy();

    // =>  METHODS
    const deleteMapping = async () => {
      const { status } = await axiosDelete(`/finance/mapping`, {
        id: props.id,
      });
      if (status === 204) {
        await store.dispatch("app/setSnackBar", {
          show: true,
          text: `Le mapping a été supprimé.`,
          color: "success",
          timeout: 5000,
        });
        emit("openDialog", false);
      }
    };

    // =>  COMPUTED

    // =>  WATCH

    // =>  HOOKS

    // =>  DATA
    return {
      deleteMapping,
      emit,
    };
  },
};
</script>

<style></style>
